var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 600",
    style: {
      enableBackground: "new 0 0 800 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#F3BA2F;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#131415;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Light"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OneArt-_x2022_-Desktop-_x2022_-Light",
    transform: "translate(-457.000000, -1515.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Block",
    transform: "translate(41.000000, 1263.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TVL",
    transform: "translate(48.000000, 252.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons_x2F_Icon-24_x2F_cake",
    transform: "translate(368.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    className: "st0",
    cx: 399.8,
    cy: 299.6,
    r: 230.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icons_x2F_icon-24_x2F_networks_x2F_binance_x5F_smart_x5F_chain",
    transform: "translate(3.333333, 3.333333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    className: "st1",
    d: "M456.3,320.8l34.8,34.7L396.5,450L302,355.5l34.8-34.7l59.7,59.7L456.3,320.8z  M396.5,261l35.3,35.3h0l0,0l-35.3,35.3l-35.2-35.2l0-0.1l0,0l6.2-6.2l3-3L396.5,261z M277.5,261.5l34.8,34.8L277.5,331 l-34.8-34.8L277.5,261.5z M515.5,261.5l34.8,34.8L515.5,331l-34.8-34.8L515.5,261.5z M396.5,142.5L491,237l-34.8,34.8 L396.5,212l-59.7,59.7L302,237L396.5,142.5z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsc);
export default __webpack_public_path__ + "static/media/bsc.04cbe1a60556d029ccb8f29029f289d4.svg";
export { ForwardRef as ReactComponent };